import { CalculatorStyleTokens } from "@/brand/productConfiguration/calculator/calculator.tokens";

export const CalculatorStyles: CalculatorStyleTokens = {
    submitButton: {
        color: "primary"
    }
};
